import { Notify } from "quasar"
import { boot } from "quasar/wrappers"
import { Icons } from "src/util/enums/fontAwesomeIcons"

export default boot(() => {
  Notify.registerType("sfx-notification", {
    color: "secondary",
    textColor: "white",
    classes: "sfx-notification text-subtitle1",
    iconSize: "32px",
  })

  Notify.registerType("sfx-notification-error", {
    color: "negative",
    textColor: "white",
    classes: "sfx-notification text-subtitle1",
    icon: Icons.ERROR,
    iconSize: "32px",
  })

  Notify.registerType("sfx-notification-accent", {
    color: "accent",
    textColor: "white",
    classes: "sfx-notification text-subtitle1",
    iconSize: "32px",
  })

  Notify.registerType("sfx-notification-warning", {
    color: "warning",
    textColor: "white",
    classes: "sfx-notification text-subtitle1",
    icon: Icons.WARNING,
    iconSize: "32px",
  })
})
